import { getPostNum } from "../../../../constant/General";

function ResultTable({ posts }) {

    return (<div className="w-50 overflow-hidden d-flex justify-content-center align-items-center">
        <div style={{
            padding: "10px"
        }} className="w-100 h-100">
            <div style={{
                fontSize: "110px",
                marginLeft: "245px",
            }} className="post w-100">
                {posts.map((post, i) => {
                    return <div
                        style={{
                            height: "110px", marginBottom: "21px"
                        }}
                        className="d-flex" key={i}>
                        <div style={{
                            marginRight: "100px", width: "130px"
                        }}>{getPostNum(post.twoD)}</div>
                        <div>{getPostNum(post.threeD)}</div>
                    </div>
                })}
            </div>
        </div>
    </div>);
}

export default ResultTable;